import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Users, AlertTriangle, CheckCircle2 } from "lucide-react";

const MONTHS = ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"];

export default function TeamOverviewCard() {
  const [data, setData] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/dashboard/team-overview").then((r) => setData(r.data)).catch(() => setData(null));
  }, []);

  if (!data || !data.team || data.team.length === 0) return null;
  const monthLabel = `${MONTHS[(data.month || 1) - 1]} ${data.year}`;

  return (
    <div className="rounded-xl border border-border bg-card p-5 mb-4" data-testid="team-overview-card">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Users className="w-4 h-4 text-muted-foreground" strokeWidth={1.75} />
          <span className="label-caps">Teamoversikt · {monthLabel}</span>
        </div>
        <span className="text-xs text-muted-foreground" data-testid="team-behind-count">
          {data.behind_count > 0 ? `${data.behind_count} av ${data.team_count} mangler arbeid` : "Alle à jour"}
        </span>
      </div>
      <div className="space-y-1.5">
        {data.team.map((m) => (
          <button key={m.user_id} onClick={() => nav("/ansatt")} data-testid={`team-member-${m.user_id}`}
            className="w-full flex items-center justify-between gap-3 rounded-lg border border-border/60 bg-secondary/40 px-3 py-2 text-left hover:bg-secondary transition-colors">
            <div className="min-w-0">
              <p className="text-sm font-medium truncate">{m.name}</p>
              <p className="text-xs text-muted-foreground truncate">{m.role_label}</p>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              {m.behind ? (
                <>
                  {m.oppdrag_missing_done > 0 && <span className="text-xs rounded-full bg-amber-500/15 text-amber-500 px-2 py-0.5" data-testid={`team-missing-done-${m.user_id}`}>{m.oppdrag_missing_done} uutført</span>}
                  {m.oppdrag_missing_qa > 0 && <span className="text-xs rounded-full bg-orange-500/15 text-orange-400 px-2 py-0.5" data-testid={`team-missing-qa-${m.user_id}`}>{m.oppdrag_missing_qa} uten KS</span>}
                  {m.tasks_missing > 0 && <span className="text-xs rounded-full bg-red-500/15 text-red-400 px-2 py-0.5" data-testid={`team-missing-tasks-${m.user_id}`}>{m.tasks_missing} oppgaver</span>}
                  <AlertTriangle className="w-4 h-4 text-amber-500" strokeWidth={1.75} />
                </>
              ) : (
                <CheckCircle2 className="w-4 h-4 text-emerald-500" strokeWidth={1.75} />
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
